import {useEffect, useRef, useState} from 'react';

import {useTranslation} from '/provider/TranslationProvider';
import {generateCallback} from '/util/component.util';

export const useCandidateProfile = ({
  hasProfile,
  fetchData,
  getDispositionOptions,
  hasdispositionOptions,
}: any) => {
  const {tt} = useTranslation('screen.CandidateProfile');

  useEffect(() => {
    if (!hasProfile) {
      fetchData();
    }
  }, [hasProfile, fetchData]);

  useEffect(() => {
    if (!hasdispositionOptions) {
      getDispositionOptions();
    }
  }, [hasdispositionOptions, getDispositionOptions]);

  return {tt};
};

export function useRefresh(refreshCachedMetrics: () => Promise<any>) {
  const [refreshing, setRefreshing] = useState(false);

  const onRefreshRef = useRef(() => {
    setRefreshing(true);

    refreshCachedMetrics().then(
      generateCallback({func: setRefreshing, params: false}),
    );
  });

  return {refreshing, onRefreshRef: onRefreshRef.current};
}
